@if (user) {
	<div [ngClass]="userImageClasses" class="td sst_userFoto" style="padding: 5px">
		<span class="sst_userPic">
			<!-- ein mitgegebenes bild, macht bei listen einen sinn -->
			@if (imageUrl) {
				<img [src]="imageUrl" />
			}
			<!-- berechnet das image bzw. die initialen-->
			@if (!imageUrl) {
				<img [src]="user | userImage" style="height: 100%" />
			}
		</span>
	</div>
	@if (td && !justImage) {
		<div class="td sst_userName">
			{{ user.firstname }}
		</div>
	}
	@if (td && !justImage) {
		<div class="td sst_surName">
			{{ user.lastname }}
		</div>
	}
	@if (!td && !justImage) {
		<span> {{ user.firstname }} {{ user.lastname }} </span>
	}
}
